import { RequestBasePageIds, RequestBaseSet, RequestDeleteIds, ResponseBasePage, ResponseBaseSet } from "src/app/modules/fwcore/models";
import { Glossary } from "src/app/features/prob/models";


/**
 * Request parameters for retrieving glossary entries.
 * Extends base pagination and ID filtering capabilities.
 */
export class RequestGlossary extends RequestBasePageIds {
  /**
   * The identifier of the deal group this glossary entry is associated with.
   */
  dealGroupId?: string | null;

  /**
   * The identifier of the deal type this glossary entry is associated with.
   */
  dealTypeId?: string | null;

  /**
   * The identifier of the tower this glossary entry is associated with.
   */
  towerId?: string | null;

  /**
   * The identifier of the application tag this glossary entry is associated with.
   */
  appTagId?: string | null;

  name?: string | null;

  description?: string | null;

  SortBy?: string | null;

  search?: string | null;

}

/**
 * Response containing glossary entries with pagination information.
 * Includes the retrieved glossary items and metadata about the result set.
 */
export class ResponseGlossary extends ResponseBasePage<Glossary> {
}

/**
 * Request parameters for creating or updating glossary entries.
 * Contains the glossary data to be persisted.
 */
export class RequestGlossarySet extends RequestBaseSet<Glossary> {
}

/**
 * Response from creating or updating glossary entries.
 * Contains the result of the set operation including any created or modified glossary entries.
 */
export class ResponseGlossarySet extends ResponseBaseSet<Glossary> {
}

export class RequestGlossaryDelete extends RequestDeleteIds {
}
